import { DataTable } from '@/components/ui/data-table/DataTable';
import { columns } from './columns';
import { columnsDedicateInstance } from './type';
import { useNavigate } from 'react-router-dom';

type Props = {
  data: columnsDedicateInstance[];
  isLoading?: boolean;
};
const InstanceTable = ({ data, isLoading }: Props) => {
  const navigate = useNavigate();
  return (
    <div className="">
      <DataTable
        columns={columns}
        data={data}
        slots={{
          pagination: {
            isSelectPageSize: false,
          },
        }}
        isLoading={isLoading}
        onClickRow={(row) => {
          navigate(row.getValue('id'));
        }}
      />
    </div>
  );
};

export default InstanceTable;
